import projectRootReducer from "./projectRootSlice";
import billingReducer from "./billingSlice";
import deliveryReducer from "./deliverySlice";
import accessoryReducer from "./accessorySlice";
import {initialState} from "./initalState";
import vaultElementSlice from "./vaultElementSlice";

export const projectReducer = (state = initialState, action) => {
    const rootState = projectRootReducer(state, action)
    const deliveryState = deliveryReducer(rootState.delivery, action)
    const billingState = billingReducer(rootState.billing, action)
    const accessoryState = accessoryReducer(rootState.accessory, action)
    const vaultElementState = vaultElementSlice(rootState.vaultElement, action);

    if (rootState.delivery === deliveryState
        && rootState.billing === billingState
        && rootState.vaultElement === vaultElementState
        && rootState.accessory === accessoryState) return rootState;
    const {delivery, billing, accessory, vaultElements, ...others} = rootState;

    return {
        ...others, vaultElement: vaultElementState, delivery: deliveryState, accessory: accessoryState, ...(
            billingState && {billing: billingState}
        )
    };
}
